module.exports = __webpack_public_path__ + "static/media/winner-list-bg.b7e942fe.png";